import { deprecated } from "typesafe-actions";

import type { DrawingPartInformationFetchResults } from "@/shop/types/drawings";

import { DrawingActionType } from "./constants";
import type { DrawingCoordinate, DrawingDetails } from "./types";

const { createStandardAction } = deprecated;

// drawing details
export const fetchDrawingDetails = createStandardAction(DrawingActionType.FETCH_DRAWING_DETAILS_START)();
export const fetchDrawingDetailsSuccess = createStandardAction(DrawingActionType.FETCH_DRAWING_DETAILS_SUCCESS)<DrawingDetails>();
export const fetchDrawingDetailsFail = createStandardAction(DrawingActionType.FETCH_DRAWING_DETAILS_FAIL).map((payload: Error) => ({
  payload,
  error: true
}));

// drawing coordinates
export const fetchDrawingCoordinatesStart = createStandardAction(DrawingActionType.FETCH_DRAWING_COORDINATES_START)();
export const fetchDrawingCoordinatesSuccess = createStandardAction(DrawingActionType.FETCH_DRAWING_COORDINATES_SUCCESS)<DrawingCoordinate[]>();
export const fetchDrawingCoordinatesFail = createStandardAction(DrawingActionType.FETCH_DRAWING_COORDINATES_FAIL).map((payload: Error) => ({
  payload,
  error: true
}));

// part information
export const fetchDrawingPartInformationStart = createStandardAction(DrawingActionType.FETCH_DRAWING_PART_INFORMATION_START)();
export const fetchDrawingPartInformationSuccess = createStandardAction(
  DrawingActionType.FETCH_DRAWING_PART_INFORMATION_SUCCESS
)<DrawingPartInformationFetchResults>();
export const fetchDrawingPartInformationFail = createStandardAction(DrawingActionType.FETCH_DRAWING_PART_INFORMATION_FAIL).map((payload: Error) => ({
  payload,
  error: true
}));

// current machine
export const updateCurrentMachineSuccess = createStandardAction(DrawingActionType.UPDATE_DRAWING_MACHINE_SUCCESS)<string>();
export const updateCurrentMachineFail = createStandardAction(DrawingActionType.UPDATE_DRAWING_MACHINE_FAIL).map((payload: Error) => ({ payload, error: true }));

// misc
export const updateClickableDrawingsState = createStandardAction(DrawingActionType.UPDATE_DRAWING_STORE_STATE)<string>();
export const resetClickableDrawingsState = createStandardAction(DrawingActionType.RESET_DRAWING_STORE_STATE)();

// part selection
export const setSelectedDrawingPart = createStandardAction(DrawingActionType.SET_SELECTED_DRAWING_PART).map((payload: { partNumber: string; uId: string }) => ({
  payload
}));

// drawing image info
export const fetchDrawingImageByNameStart = createStandardAction(DrawingActionType.FETCH_DRAWING_IMAGE_BY_NAME_START)();
export const fetchDrawingImageByNameSuccess = createStandardAction(DrawingActionType.FETCH_DRAWING_IMAGE_BY_NAME_SUCCESS).map((imageIsAvailable: boolean) => ({
  payload: imageIsAvailable
}));
export const fetchDrawingImageByNameFail = createStandardAction(DrawingActionType.FETCH_DRAWING_IMAGE_BY_NAME_FAIL).map((payload: Error) => ({
  payload,
  error: true
}));
